import 'angular';
import './approval_people_panel.html';
import './approval_people_panel.scss';

import '../approverInLevelDisplay/approverInLevelDisplay'
import '../approvalActionModal/ApprovalActionModalController'

import {IAuthenticatedUserService} from "../../../types/ServiceTypes";
import {RootScope} from "../../../types/angular-types";
import {ApprovalInfo, ApprovalState, ApprovalStatus, ApprovalService, ApprovalOperationName, ApprovalDetailsService, ApprovalDetailsServiceMode} from "../../approvals-types"
import SignalProvider from '../../../gorillaboy/SignalProvider';
import {find} from 'lodash-es';

interface IScope extends RootScope {
    // properties
    approvalRequest: ApprovalInfo

    // methods
    isApprovalOwner: () => boolean;
    showCancelApprovalRequestButton: (approvalRequest: ApprovalInfo) => boolean;
    showEditApprovalRequestButton: (approvalRequest: ApprovalInfo) => boolean;
    openActionModal: () => void;
    cancelApprovalRequestClickHandler: () => void;
    editApprovalRequestClickHandler: () => void;
    getApprovalStatusText: (approvalRequest: ApprovalInfo) => string;
}

angular.module('GorillaBoy.Approvals')
    .directive('approvalPeoplePanel', ['$rootScope', '$uibModal', '$translate', '$location', 'authenticatedUser', 'ApprovalService', 'ApprovalDetailsService',
        ($rootScope:RootScope, $uibModal: any, $translate: ng.translate.ITranslateService, $location:ng.ILocationService, authenticatedUser: IAuthenticatedUserService, ApprovalService: ApprovalService, ApprovalDetailsService: ApprovalDetailsService) => {
        return {
            restrict: 'E',
            scope: {
                approvalRequest: '='
            },
            templateUrl: './approvals/approvalView/approvalPeoplePanel/approval_people_panel.html',
            link: function($scope: IScope, $element, attrs) {
                $scope.openActionModal = () => {
                    var modalHandle = $uibModal.open({
                        templateUrl: './approvals/approvalView/approvalActionModal/approval_action_modal.html',
                        controller: 'ApprovalActionModalController',
                        size: 'md',
                        windowClass: 'approval-modal',
                        resolve: {
                            approvalRequest: () => $scope.approvalRequest
                        }
                    });
                    postProcessModalOpening(modalHandle);
                };

                $scope.isApprovalOwner = () => {
                    return $scope.approvalRequest.Owner.UserId === authenticatedUser.getUserInfo().Id;
                };

                $scope.cancelApprovalRequestClickHandler = () => {
                    ApprovalService.UpdateApproval($scope.approvalRequest.Id, ApprovalOperationName.CANCEL, null).then(() => {
                        $rootScope.$broadcast(SignalProvider.Approval.view.updateApprovalRequest);
                    });;
                };

                $scope.editApprovalRequestClickHandler = () => {
                    // populate the store with current approval request data
                    ApprovalDetailsService.initService($scope.approvalRequest, ApprovalDetailsServiceMode.EDIT);
                    ApprovalDetailsService.setPanelVisibility(true);
                    // redirect to mydocs with approval panel open
                    $location.url("/mydocs");
                };

                $scope.showCancelApprovalRequestButton = (approvalRequest: ApprovalInfo) => {
                    return approvalRequest.State !== ApprovalState.APPROVED
                        && approvalRequest.State !== ApprovalState.REJECTED
                        && approvalRequest.State !== ApprovalState.CANCELLED;
                };

                $scope.showEditApprovalRequestButton = (approvalRequest: ApprovalInfo) => {
                    return approvalRequest.State !== ApprovalState.APPROVED
                        && approvalRequest.State !== ApprovalState.REJECTED
                        && approvalRequest.State !== ApprovalState.CANCELLED;
                };

                $scope.showApproveOrRejectButton = (approvalRequest: ApprovalInfo) => {
                    let approvalRequestIsInActionableState = approvalRequest.State === ApprovalState.ACTIONED
                        || approvalRequest.State === ApprovalState.PUBLISHED;
                    let currentLevelConfig = find(approvalRequest.LevelConfigs, (level) => level.LevelNumber === approvalRequest.CurrentLevel);
                    let currentUserIsActiveApprover = currentLevelConfig.approvers.some((approver) => {
                        let currentLevelHasTheCurrentUser = approver.UserId === authenticatedUser.getUserInfo().Id;
                        let userHasMadeDecision = approver.Status === ApprovalStatus.APPROVED || approver.Status === ApprovalStatus.REJECTED;
                        return currentLevelHasTheCurrentUser && !userHasMadeDecision;
                    });
                    return approvalRequestIsInActionableState && currentUserIsActiveApprover;
                };

                $scope.getApprovalStatusText = (approvalRequest: ApprovalInfo) => {
                    if (approvalRequest.State === ApprovalState.APPROVED) {
                        return $translate.instant('APPROVALS.VIEWER.PEOPLE_PANEL.APPROVED_MESSAGE');
                    } else if (approvalRequest.State === ApprovalState.REJECTED) {
                        return $translate.instant('APPROVALS.VIEWER.PEOPLE_PANEL.REJECTED_MESSAGE');
                    } else if (approvalRequest.State === ApprovalState.CANCELLED) {
                        return $translate.instant('APPROVALS.VIEWER.PEOPLE_PANEL.CANCELED_MESSAGE');
                    } else {
                        return $translate.instant('APPROVALS.VIEWER.PEOPLE_PANEL.APPROVAL_IS_AT_TEXT', {
                            alphabet: $scope.approvalRequest.CurrentLevel
                        })
                    }
                }

                function postProcessModalOpening(modalHandle) {
                    $scope.$on("$destroy", function() {
                        if (modalHandle) {
                            modalHandle.close();
                        }
                    });
                }
            }
        };
    }]);